import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.75 8.99999C15.75 9.1989 15.671 9.38966 15.5303 9.53032L11.0303 14.0303C10.7374 14.3232 10.2626 14.3232 9.96967 14.0303C9.67678 13.7374 9.67678 13.2626 9.96967 12.9697L13.1893 9.74999H3C2.58579 9.74999 2.25 9.4142 2.25 8.99999C2.25 8.58577 2.58579 8.24999 3 8.24999H13.1893L9.96967 5.03033C9.67678 4.73744 9.67678 4.26256 9.96967 3.96967C10.2626 3.67678 10.7374 3.67678 11.0303 3.96967L15.5303 8.46966C15.671 8.61031 15.75 8.80107 15.75 8.99999Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }